export const API_BOT = {
  DEFAULT_API_URL: '/bo/api_bot/',
  DEFAULT_TOKEN: 'rbU3wK99BGS31Og8kbZiiOrLMTtTXUhJ&usecase=ZyXFfG2T0v',
  SETTINGS_API_URL: 'settings.php',
  USE_CASE_API_URL: 'usecase.php',
  BOT_API_URL: 'bot.php',
}
